import { AuthLayout, LoginForm } from 'src/features/auth/components';

const Login = () => {
    return (
        <AuthLayout>
            <LoginForm />
        </AuthLayout>
    );
};

export { Login };
